import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" {...props}><circle cx="16" cy="16" r="15.25" stroke="currentColor" strokeWidth="1.5" /><path fill="currentColor" fillRule="evenodd" d="M13.68 10.03a.94.94 0 011.33 0l5.31 5.3c.37.37.37.97 0 1.34l-5.3 5.3a.94.94 0 01-1.34-1.33L18.32 16l-4.64-4.64a.94.94 0 010-1.33z" clipRule="evenodd" /></svg>);